import React from 'react';
import { useLocale } from '../../contexts/LocaleContext';
import { useAuth } from '../../contexts/AuthContext';
import { translations } from '../../translations';

/**
 * LanguageSwitcher Component
 * Allows users to switch between native language and English
 * Only visible for non-English countries (BR, AR)
 */
const LanguageSwitcher = ({ className = '' }) => {
  const { language, locale, setLanguage } = useLocale();
  const { updateUserProfile } = useAuth();

  // Don't show switcher if locale config says English is the language
  if (!locale || locale.language === 'en') {
    return null;
  }

  // Get the native language name
  const nativeLanguage = locale.language; // 'pt' or 'es'
  const nativeLanguageName = nativeLanguage === 'pt'
    ? translations.pt.language.portuguese
    : translations.es.language.spanish;

  const handleLanguageChange = (newLang) => {
    // Pass updateUserProfile function to save to Firebase
    setLanguage(newLang, updateUserProfile);
  };

  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      <button
        onClick={() => handleLanguageChange(nativeLanguage)}
        className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${
          language === nativeLanguage
            ? 'bg-green-600 text-white'
            : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
        }`}
        aria-label={`Switch to ${nativeLanguageName}`}
      >
        {nativeLanguage === 'pt' && '🇧🇷'} {nativeLanguage === 'es' && '🇦🇷'} {nativeLanguageName}
      </button>

      <span className="text-gray-400">|</span>

      <button
        onClick={() => handleLanguageChange('en')}
        className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${
          language === 'en'
            ? 'bg-green-600 text-white'
            : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
        }`}
        aria-label="Switch to English"
      >
        🇺🇸 English
      </button>
    </div>
  );
};

export default LanguageSwitcher;
